module.exports = __webpack_public_path__ + "static/media/discovery_pack_128x128.da72e627.png";